export default function PageLoader() {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--color-bg)]">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-10 h-10">
          <div className="absolute inset-0 rounded-full border-2 border-white/10" />
          <div className="absolute inset-0 rounded-full border-2 border-t-[var(--color-accent)] animate-spin" />
        </div>
        <span className="text-[var(--color-muted)] text-xs uppercase tracking-widest">Loading</span>
      </div>
    </div>
  );
}
